import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { FileStatus } from '@/components/ui/file-uploaded/types';

export const useFileUpload = () => {
	const fileInputRef = useRef<HTMLInputElement | null>(null);
	const [file, setFile] = useState<File>();
	const [fileReader, setFileReader] = useState<FileReader>();
	const [status, setStatus] = useState<FileStatus>();

	const onFileChange = (event: ChangeEvent<HTMLInputElement>) => {
		const file = event.target.files?.[0];
		if (!file) return;

		const fileReader = new FileReader();
		fileReader.readAsDataURL(file);

		setFile(file);
		setFileReader(fileReader);
	};

	const onFileRemoved = () => {
		setFile(undefined);
		setStatus(undefined);
		setFileReader(undefined);
		if (fileInputRef.current) {
			fileInputRef.current.value = '';
		}
	};

	useEffect(() => {
		if (fileReader) {
			fileReader.onloadstart = () => setStatus(FileStatus.LOADING);
			fileReader.onloadend = () => setStatus(FileStatus.LOADED);
		}
	}, [fileReader, setStatus]);

	return { fileInputRef, file, status, onFileChange, onFileRemoved, setFile, setStatus };
};
